module.exports = __webpack_public_path__ + "1793882494189/images/paypal.744232e.png";